import { Box, Button, Typography } from '@mui/material';
import withBoxStyle from '../../../../HOC/layout/withBoxStyle';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../redux/hooks';
import LoginRegistrationHeader from '../../../../components/layout/LoginRegistrationHeader';
import GroupIcon from '/images/Group.svg';

const ExploreEyeOps = withBoxStyle(() => {
  const navigate = useNavigate();

  const isFirstTimeLogin = useAppSelector(
    (state) => state.auth.currentUser?.patientPlatformFirstLogin
  );

  if (!isFirstTimeLogin) {
    return <Navigate to={'/dashboard'} replace />;
  }

  return (
    <Box sx={{ p: 3 }} className="d-flex flex-column flex-1">
      <LoginRegistrationHeader />
      <Box pt={5}>
        <Typography variant="h4" color="primary" mb={1.5}>
          Great! You're all set now
        </Typography>
        <Typography variant="body1">
          Now that you've created your account, you can start enjoying all the
          benefits of our tailored care.
        </Typography>
      </Box>
      <Box
        className="d-flex align-items-center justify-content-center overflow-hidden"
        mt="auto"
      >
        <img src={GroupIcon} alt="Group" />
      </Box>
      <Box sx={{ pt: 7.5, mt: 'auto', mb: 4.5 }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => {
            navigate('/carousel', { replace: true });
          }}
        >
          Start exploring Eye Op
        </Button>
      </Box>
    </Box>
  );
});
export default ExploreEyeOps;
